import React from 'react'
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import { ListItem } from '@mui/material';


const AntSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : 'rgb(30,60,114)',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const RolesPermissions = ({adminRolesList,handleRoleChange,handleSaveData,filterValue,updatedPermissionList,handleSwitchChange}) => {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
              {adminRolesList?.data?.map((role) => (
                <MenuItem key={role.id} className='rolesList' selected={ filterValue === role.id } onClick={handleRoleChange} value={role.id}>{role.name}</MenuItem>
              ))}
          </Grid>  
          <Grid item sm={5} xs={8}> 
              <ListItem className='headingItem'>Action</ListItem>
              <Grid container>
                {updatedPermissionList.map((permission,index) => {
                  return (
                    <ListItem key={index} className='actionList'>{permission.permission_name}</ListItem>
                  )
                })}
              </Grid>
          </Grid>
          <Grid item sm={3} xs={4}>
            <ListItem className='headingItem'>Permission</ListItem> 
              {updatedPermissionList.map((permission,index) => {
                  return (
                    <ListItem key={index} className='permissionListButton'>
                    <FormControlLabel value={index}  
                      control={ 
                        <><AntSwitch
                          key={permission.id}
                          checked={permission.checked}
                          onChange={handleSwitchChange(permission.id)}
                          value={permission.id || ''}
                          inputProps={{ 'aria-label': 'controlled' }} />
                        </>
                      } 
                    />
                    </ListItem>
                  )
                })}   
          </Grid>
          <Grid item xs={12}> 
            <Button variant="contained"
              size="small"
              color="primary" onClick={handleSaveData}> Update </Button>
            </Grid>
          </Grid>
      </Box>
    )
}


export default RolesPermissions;